import React, { Component } from 'react';
import './Success.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import WeighTabs from './WeighTabs/WeighTabs';
import SelectedSegmentAttractivenessError from './SelectedSegmentAttractivenessError/SelectedSegmentAttractivenessError';
import jsPDF from 'jspdf';
import rasterizeHTML from 'rasterizehtml';

class Success extends Component {
    constructor(props) {
        super(props);
        this.state = {
            createdData: false,
            editedData: false,
            createCriterialModal: false,
            tabs: [],
            attractivenessData: [],
            addedNewItemState: false,
            selectedSegmentAttractivenessError:false,
            weighting: [],
            segmentAttractivness: [],
            weightingNumber: [],
            weightingArrayIsEmpty: true,
            segmentAttractivnessIsEmpty: true,
            scoreNumber: 0,
            stepValidation: false,
            thirdStepValidation: [],
            pdfVal: false,
        }
    }

    componentWillMount() {
        let body = {
            projectId: this.props.projectId,
            type: "attractivness"
        }
        let data = {
            projectId: this.props.projectId,
            type: "segmentation"
        }
        this.props.getCustomerGroup(data)
        // let data = {
        //     groupId: this.props.projectId,
        // }

        //this.props.getSegmentsName(data)
        this.props.getAttractivness(body)

    }

    componentWillReceiveProps(nextProps) {
        if( nextProps.attractivnessData.Items && _.isEmpty(this.state.attractivenessData) ){

            if (!nextProps.attractivnessFetching && !_.isEmpty(nextProps.attractivnessData.Items)  &&  !_.isEmpty(nextProps.getCustomerGroupsData)) {
                let data =[]
                nextProps.attractivnessData.Items[0].attractivness.map(item=>{
                    if( item.important ){
                        data.push(item)
                    }
                })

                this.setState({
                    attractivenessData: data,
                    editedData : true, createdData : false,
                });

                //this.addedNewItem(true);
                let tabTitleArr = [];
                nextProps.attractivnessData.Items[0].attractivness.map(item=>{
                    let data = nextProps.getCustomerGroupsData.find(r => r.groupId === item.groupId);
                    tabTitleArr.push({
                        groupId: data.groupId,
                        groupName: data.groupName
                        //attractivnessId: uuidv1(),
                    });

                });

                let newData = _.uniqBy(tabTitleArr, 'groupId')
                newData.map(item=>{
                    this.state.tabs.push(item)
                })
            }

            if (!nextProps.attractivnessFetching && nextProps.attractivnessData.Items[0].weighting && !_.isEmpty(nextProps.attractivnessData.Items[0].weighting) && this.state.weightingArrayIsEmpty) {

                nextProps.attractivnessData.Items[0].weighting.map(item=>{
                    this.state.weighting.push(item)
                })

                this.setState({
                    weighting: this.state.weighting,
                    weightingArrayIsEmpty : false
                }, () => this.weightingNumber());

            }

            if (!nextProps.attractivnessFetching && nextProps.attractivnessData.Items[0].segmentAttractivness && !_.isEmpty(nextProps.attractivnessData.Items[0].segmentAttractivness) && this.state.segmentAttractivnessIsEmpty) {

                nextProps.attractivnessData.Items[0].segmentAttractivness.map(item=>{
                    this.state.segmentAttractivness.push(item)
                })

                this.setState({
                    segmentAttractivness: this.state.segmentAttractivness,
                    segmentAttractivnessIsEmpty : false
                });

            }



            if( _.isEmpty(nextProps.attractivnessData.Items) && !this.state.createdData){
                this.setState({createdData : true, editedData: false })
            }
        }

    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                <div className='rect1'/>
                <div className='rect2'/>
                <div className='rect3'/>
                <div className='rect4'/>
                <div className='rect5'/>
                </div>
            </div>
        );
    }

    onChangeRatingValue = (e, data, segmentData) => {
        let oldItem;
        let newItem;
        let value = e.target.value;

        newItem = data.attractivnessId;
        let exist = this.state.segmentAttractivness.find(r => ( r.attractivnessId === data.attractivnessId) && ( r.segmentId === segmentData.segmentId) )

        if(exist){
            exist.value = value
        }else {
            this.state.segmentAttractivness.push({
                attractivnessId: data.attractivnessId,
                value: value,
                segmentId: segmentData.segmentId
            })
        }
        this.setState({ segmentAttractivness: this.state.segmentAttractivness }, () => this.weightingNumber() )
    }

    weightingNumber = () => {
        let dataArr = 0;
        this.state.weighting.map(item=>{
            let parentTab = this.state.attractivenessData.find(r => r.attractivnessId === item.attractivnessId);
            let parentTabFromTabs = this.state.tabs.find(r => r.groupId === parentTab.groupId);
            dataArr = dataArr + +item.value

        })


        this.setState({ weightingNumber : dataArr});

        // if(_.isEmpty(this.state.segmentAttractivness)){
        //     this.setState({ weightingNumber : dataArr});
        // }

    }

    selectedSegmentAttractivenessErrorModa = () => {
        this.setState({  selectedSegmentAttractivenessError : !this.state.selectedSegmentAttractivenessError })
    }

    onNextButtonClick = () => {

            let body = {
                id: this.props.attractivnessData.Items[0].id,
                projectId: this.props.projectId,
                type: "attractivness",
                attractivness: this.state.attractivenessData,
                weighting: this.state.weighting,
                segmentAttractivness: this.state.segmentAttractivness,

            }

            this.props.editCriteriaTab(body);
            this.props.stateNext();

    }

    printDocument = (e) => {
        e.preventDefault();
        const canvas = document.createElement('canvas');
        canvas.height = 1000;
        canvas.width = 1500;
        // canvas.textAlign = "center";

        let html = `<div>
                        <h2 style='font-size: 18px; color: #333333; margin: 0px 0px 0px 0px'>Results</h2>
                        <br/>
                        ${ this.state.tabs.map((tabsItem, tabsKey) => {
                            let tabWaitingAmount = 0;
                            let scoreValArr = [];
                            return `<div style=" width: 700px; margin-bottom: 20px">

                                <div style="margin-bottom: 20px">
                                    <div>
                                        ${tabsItem.groupName}
                                    </div>
                                </div>

                                <table style="width: 100%">
                                    <thead>
                                        <th style="font-size: 12px; width: 12.5%;">Criteria of Attractiveness</th>
                                        <th style="font-size: 12px; width: 12.5%;">Weighting <br/> (1-100) </th>
                                        ${this.props.getSegmentData.Items.map((segmentItem, key) => {
                                            if( tabsItem.groupId === segmentItem.groupId ){
                                                return(
                                                    `<th style="width: 12.5%; font-size: 12px;">
                                                        <div style="width: 100%">
                                                            ${segmentItem.name}
                                                        </div>
                                                        <div style="width: 40%; float: left; font-size: 11px;">
                                                            Rating <br/> <span>(1-10)</span>
                                                        </div>
                                                        <div style="width: 40%; float: right; font-size: 11px;">
                                                            Score
                                                        </div>
                                                    </th>`
                                                )
                                            }

                                        }).join('')}

                                    </thead>
                                    <tbody>
                                        ${this.state.attractivenessData.map((item, key) => {
                                            if(tabsItem.groupId === item.groupId){
                                                let defaultData = this.state.weighting.find(r => r.attractivnessId === item.attractivnessId);
                                                return(
                                                    `<tr>
                                                        <td style="width: 12.5%; font-size: 12px; text-align: center ">
                                                            ${item.name}
                                                        </td>
                                                        <td style="width: 12.5%; font-size: 12px; text-align: center">
                                                            ${defaultData ? defaultData.value : ''}
                                                        </td>

                                                        ${ this.props.getSegmentData.Items.map((segmentdataItem, key) => {
                                                            let getselectData = this.state.segmentAttractivness.find(r => (r.attractivnessId === item.attractivnessId) && (r.segmentId ===  segmentdataItem.segmentId ));

                                                            let number = this.state.weighting.find(r => r.attractivnessId === item.attractivnessId);

                                                            let score = number ? (getselectData ? +getselectData.value * +number.value : +number.value)  : 0;

                                                            if(tabsItem.groupId === segmentdataItem.groupId){

                                                                let defaultData = this.state.segmentAttractivness.find(r => (r.attractivnessId === item.attractivnessId) && (r.segmentId === segmentdataItem.segmentId ));

                                                                return(
                                                                    `<td style="width: 12.5%; ">
                                                                <div style="width: 40%; float: left; font-size: 11px; text-align: center">
                                                                    ${defaultData ? defaultData.value : 1}
                                                                </div>
                                                                <div style="width: 40%; float: right; font-size: 11px; text-align: center">
                                                                    ${score}
                                                                </div>
                                                                    </td>`
                                                                )


                                                            }

                                                        }).join('')}


                                                    </tr>`
                                                )
                                            }
                                        }).join('')}

                                        <tr>
                                            ${this.state.attractivenessData.map((item, key) => {
                                                if(tabsItem.groupId === item.groupId){

                                                    tabWaitingAmount = +tabWaitingAmount + +(this.state.weighting.find(r => r.attractivnessId === item.attractivnessId) ? this.state.weighting.find(r => r.attractivnessId === item.attractivnessId).value : 0)
                                                }

                                                this.props.getSegmentData.Items.map((segmentdataItem, key) => {
                                                    if( item.groupId === segmentdataItem.groupId){
                                                        scoreValArr.push({
                                                            attractivnessId: item.attractivnessId,
                                                            attractivnessName: item.name,
                                                            segmentId: segmentdataItem.segmentId,
                                                            segmentName: segmentdataItem.name
                                                        })
                                                    }
                                                })


                                            }).join('')}

                                            <td style="width: 12.5%; font-size: 12px; text-align: center " ></td>

                                            <td style="width: 12.5%; font-size: 12px; text-align: center ">
                                                <strong>${tabWaitingAmount}</strong>
                                            </td>
                                            ${ this.props.getSegmentData.Items.map((segmentItem,
                                                key) => {
                                                    let colScoreArr = [];
                                                    scoreValArr.map((child,
                                                key) => {
                                                        if( child.segmentId === segmentItem.segmentId ){
                                                            colScoreArr.push(child);
                                                        }
                                                    });

                                                    let scoreNumberArr = [];
                                                colScoreArr.map((score,
                                                    key) => {

                                                        let getselectData = this.state.segmentAttractivness.find(r => (r.attractivnessId === score.attractivnessId) && (r.segmentId ===  segmentItem.segmentId ));

                                                        let number = this.state.weighting.find(r => r.attractivnessId === score.attractivnessId);

                                                        let value = number ? (getselectData ? +getselectData.value * +number.value : +number.value)  : 0;

                                                        scoreNumberArr.push(value);
                                                })

                                                let scoreNumber = 0;

                                                scoreNumberArr.map((number,
                                                    key) => {
                                                        return scoreNumber = scoreNumber + number;
                                                    });

                                                    if(tabsItem.groupId === segmentItem.groupId){
                                                        return (
                                                            `<td style='width: 12.5%;'>
                                                                <div style='width: 40%; font-size: 12px; text-align: center ; float: left'></div>
                                                                <div style='width: 40%; font-size: 12px; text-align: center; float: right '><strong>${scoreNumber}</strong></div>
                                                            </td>`
                                                        )
                                                    }

                                            }).join('')}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>`
                        }).join('')}

                </div>`

        rasterizeHTML.drawHTML(html, canvas).then((renderResult) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'pt', 'a4');
            pdf.addImage(imgData, 'JPEG', 0, 0);
            pdf.save('segment_Attractiveness.pdf');
        });
    }

    printPage = () => {
        let html = `<div>
                        <h2 style='font-size: 18px; color: #333333; margin: 0px 0px 0px 0px'>Results</h2>
                        <br/>

                        ${ this.state.tabs.map((tabsItem, tabsKey) => {
                            let tabWaitingAmount = 0;
                            let scoreValArr = [];
                            return `<div style=" width: 700px; margin-bottom: 20px">

                                <div style="margin-bottom: 20px">
                                    <div>
                                        ${tabsItem.groupName}
                                    </div>
                                </div>

                                <table style="width: 100%">
                                    <thead>
                                        <th style="font-size: 12px; width: 12.5%;">Criteria of Attractiveness</th>
                                        <th style="font-size: 12px; width: 12.5%;">Weighting <br/> (1-100) </th>
                                        ${this.props.getSegmentData.Items.map((segmentItem, key) => {
                                            if( tabsItem.groupId === segmentItem.groupId ){
                                                return(
                                                    `<th style="width: 12.5%; font-size: 12px;">
                                                        <div style="width: 100%">
                                                            ${segmentItem.name}
                                                        </div>
                                                        <div style="width: 40%; float: left; font-size: 11px;">
                                                            Rating <br/> <span>(1-10)</span>
                                                        </div>
                                                        <div style="width: 40%; float: right; font-size: 11px;">
                                                            Score
                                                        </div>
                                                    </th>`
                                                )
                                            }

                                        }).join('')}

                                    </thead>
                                    <tbody>
                                        ${this.state.attractivenessData.map((item, key) => {
                                            if(tabsItem.groupId === item.groupId){
                                                let defaultData = this.state.weighting.find(r => r.attractivnessId === item.attractivnessId);
                                                return(
                                                    `<tr>
                                                        <td style="width: 12.5%; font-size: 12px; text-align: center ">
                                                            ${item.name}
                                                        </td>
                                                        <td style="width: 12.5%; font-size: 12px; text-align: center">
                                                            ${defaultData ? defaultData.value : ''}
                                                        </td>

                                                        ${ this.props.getSegmentData.Items.map((segmentdataItem, key) => {
                                                            let getselectData = this.state.segmentAttractivness.find(r => (r.attractivnessId === item.attractivnessId) && (r.segmentId ===  segmentdataItem.segmentId ));

                                                            let number = this.state.weighting.find(r => r.attractivnessId === item.attractivnessId);

                                                            let score = number ? (getselectData ? +getselectData.value * +number.value : +number.value)  : 0;

                                                            if(tabsItem.groupId === segmentdataItem.groupId){

                                                                let defaultData = this.state.segmentAttractivness.find(r => (r.attractivnessId === item.attractivnessId) && (r.segmentId === segmentdataItem.segmentId ));

                                                                return(
                                                                    `<td style="width: 12.5%; ">
                                                                <div style="width: 40%; float: left; font-size: 11px; text-align: center">
                                                                    ${defaultData ? defaultData.value : 1}
                                                                </div>
                                                                <div style="width: 40%; float: right; font-size: 11px; text-align: center">
                                                                    ${score}
                                                                </div>
                                                                    </td>`
                                                                )


                                                            }

                                                        }).join('')}


                                                    </tr>`
                                                )
                                            }
                                        }).join('')}

                                        <tr>
                                            ${this.state.attractivenessData.map((item, key) => {
                                                if(tabsItem.groupId === item.groupId){

                                                    tabWaitingAmount = +tabWaitingAmount + +(this.state.weighting.find(r => r.attractivnessId === item.attractivnessId) ? this.state.weighting.find(r => r.attractivnessId === item.attractivnessId).value : 0)
                                                }

                                                this.props.getSegmentData.Items.map((segmentdataItem, key) => {
                                                    if( item.groupId === segmentdataItem.groupId){
                                                        scoreValArr.push({
                                                            attractivnessId: item.attractivnessId,
                                                            attractivnessName: item.name,
                                                            segmentId: segmentdataItem.segmentId,
                                                            segmentName: segmentdataItem.name
                                                        })
                                                    }
                                                })


                                            }).join('')}

                                            <td style="width: 12.5%; font-size: 12px; text-align: center " ></td>

                                            <td style="width: 12.5%; font-size: 12px; text-align: center ">
                                                <strong>${tabWaitingAmount}</strong>
                                            </td>
                                            ${ this.props.getSegmentData.Items.map((segmentItem,
                                                key) => {
                                                    let colScoreArr = [];
                                                    scoreValArr.map((child,
                                                key) => {
                                                        if( child.segmentId === segmentItem.segmentId ){
                                                            colScoreArr.push(child);
                                                        }
                                                    });

                                                    let scoreNumberArr = [];
                                                colScoreArr.map((score,
                                                    key) => {

                                                        let getselectData = this.state.segmentAttractivness.find(r => (r.attractivnessId === score.attractivnessId) && (r.segmentId ===  segmentItem.segmentId ));

                                                        let number = this.state.weighting.find(r => r.attractivnessId === score.attractivnessId);

                                                        let value = number ? (getselectData ? +getselectData.value * +number.value : +number.value)  : 0;

                                                        scoreNumberArr.push(value);
                                                })

                                                let scoreNumber = 0;

                                                scoreNumberArr.map((number,
                                                    key) => {
                                                        return scoreNumber = scoreNumber + number;
                                                    });

                                                    if(tabsItem.groupId === segmentItem.groupId){
                                                        return (
                                                            `<td style='width: 12.5%;'>
                                                                <div style='width: 40%; font-size: 12px; text-align: center ; float: left'></div>
                                                                <div style='width: 40%; font-size: 12px; text-align: center; float: right '><strong>${scoreNumber}</strong></div>
                                                            </td>`
                                                        )
                                                    }

                                            }).join('')}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>`
                        }).join('')}
        </div>`;
        let w = window.open();
        w.document.write(html);
        w.print();
        w.close();
    };

    downloadPDF = (e) => {
        this.printDocument(e);
    }

    render() {
        return (
            <div className='criteria-content'>
                <div className='step-bar'>
                    <div className='step step-four arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-four arrow-step'>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-four arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-four arrow-step active-step'>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>ATTRACTIVENESS</h5>
                      </div>
                    </div>
                    <div className='row'>
                        <div className="col-md-12">
                            <div className='card'>
                                <div className="card-header">
                                  <div className="col-md-12">
                                    <div className="criteria-title-box">
                                      <h5>Results</h5>
                                    </div>
                                  </div>
                                </div>
                                <div className='card-body'>
                                { ( !this.props.attractivnessFetching && this.props.attractivnessData.Items ) &&
                                    <WeighTabs
                                        getAttractivness={this.props.getAttractivness}
                                        tabs={this.state.tabs}
                                        attractivenessData={this.state.attractivenessData}
                                        getSegmentsName={this.props.getSegmentsName}
                                        getSegmentFetching={this.props.getSegmentFetching}
                                        getSegmentData={this.props.getSegmentData}
                                        onChangeRatingValue={this.onChangeRatingValue}
                                        segmentAttractivness={this.state.segmentAttractivness}
                                        weighting={this.state.weighting}
                                        weightingNumber={this.state.weightingNumber}
                                        scoreNumber={this.state.scoreNumber}
                                        projectId={this.props.projectId}
                                        thirdStepValidation={this.state.thirdStepValidation}
                                        pdfVal={this.state.pdfVal}
                                        onClickPDF={this.onClickPDF}
                                        tabStep={this.props.tabStep}
                                        onTabChange={this.props.onTabChange}
                                    />
                                }
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <Link className='btn btn-success' to={'/abilityToCompete/'+this.props.projectId}> Next </Link>
                                    <Link to='/toolkit' className='btn btn-success'> Done </Link>
                                    <div className='btn empty-btn default' onClick={this.downloadPDF}>Save PDF</div>
                                    <div className='btn empty-btn default' onClick={this.printPage}>Print</div>
                                    <div className='btn empty-btn default' onClick={() => this.props.stateBack()}>Back</div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.selectedSegmentAttractivenessError &&
                    <SelectedSegmentAttractivenessError
                        selectedSegmentAttractivenessErrorModal={this.selectedSegmentAttractivenessErrorModa}
                    />
                }
            </div>
        )
    }
}
export default (Success);



// WEBPACK FOOTER //
// ./src/components/SegmentAttractiveness/Succes/Success.jsx